<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable :min-width="160" @resizing="onResize" :max-width="400" :draggable="false"
            :handles="['mr']" :w="206" :parent="false">
            <el-scrollbar>
              <tree :isSearch="isSearch" @initFun="initQuery" @nodeClick="nodeClick"></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="dataRight">
        <div class="stateTable">
          <el-scrollbar>
            <div class="dataTable" style="margin-top: 0;">
              <!-- <div class="table-title" style="padding-top: 0;"> {{ $t('VehicleAnalysis.dayilyWorkHour') }}</div> -->
              <div class="rightAll-btn" style="padding-top: 16px;">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item :label="$t('VehicleAnalysis.num')">
                    <el-select v-model="formInline.numberType" style="width: 120px" :placeholder="$t('common.choseTip')"
                      class="selectStyle">
                      <el-option v-for="item in optionsInput" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-input size="mini" v-model="formInline.number" :placeholder="$t('common.searchTip')"
                      style="width: 150px" class="inputStyle"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.search.dateSearch')">
                    <el-date-picker class="pickerStyle" v-model="formInline.workDay" value-format="yyyy-MM-dd" type="date" :placeholder="$t('common.btn.choseDate')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch" class="btn-chaxun">{{
                      $t('common.btn.search') }}</el-button>
                    <el-button size="mini" @click="onClear" class="btn-del">{{ $t('common.btn.cancel') }}</el-button>
                  </el-form-item>
                </el-form>
                <el-button v-if="isPrimaryKey('VEHICLEANALYSIS_VEHICLEORGREPORT_CHANGE_DOWN')" type="text"
                  @click="downCar">{{ $t('common.btn.download') }}</el-button>
              </div>
              <i-table :list="list" ref="carTable" @handleSelectionChange="handleSelectionChange" :options="option"
                :columns="columns" :operates="operates"></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DailyOperationVehicles from "./DailyOperationVehicles.js";
export default DailyOperationVehicles;
</script>

<style lang="less" scoped>
.pickerStyle {
  ::v-deep .el-input__inner {
    padding-left: 30px !important;
  }
}
::v-deep .el-table .cell {
  padding: 0 !important;
}
@import "../../../assets/styles/Style.less";
</style>
